import { createContext } from 'preact';
const SelectContext = createContext(null);
export default SelectContext;
//# sourceMappingURL=SelectContext.js.map